import React, { useState } from "react";
import NavBar from "components/SideBar/SideBar2";
import { ToastContainer } from "react-toastify";
import "./style.css";
import { RingLoader } from "react-spinners";
import { useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Typography,
  InputAdornment,
} from "@material-ui/core";
import { displayValue } from "utils/randomKey";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import SearchIcon from "@material-ui/icons/Search";

import { CustomTextField } from "../utility";
const Table41 = (props) => {
  const rowStyle2 = (row, rowIndex) => {
    const style = {};
    style.backgroundColor = "#fff";
    return style;
  };
  const loaderStatus = useSelector(
    (store) => store.gstr8PrepareDataReducer.loaderStatus
  );
  const [search, setSearch] = useState('')
  const Table41Columns = [
    {
      dataField: "eid",
      text: "Revised Enrolment no. of supplier",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        return { fontFamily, fontSize, fontWeight, textAlign };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "20%",
      },
    },
    {
      dataField: "supName",
      text: "Revised Name of Supplier",
      
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        return { fontFamily, fontSize, fontWeight, textAlign };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "20%",
      },
    },

    {
      dataField: "grossValSup",
      text: "Revised Gross value of supplies made",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        return { fontFamily, fontSize, fontWeight, textAlign };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "20%",
      },
      formatter:(col, row)=>{
        return (
          <>
          {(row.grossValSup != null && row.grossValSup != undefined)?displayValue(row.grossValSup):"--"}
          </>
        )
      }
    //   formatter: (cell, row) => {
    //     return (
    //       <div
    //         style={{ width: "100%" }}
    //         onClick={row.total != "0" ? () => downloadFile(row, "total") : ""}
    //       >
    //         {row.total}
    //       </div>
    //     );
    //   },
    },

    {
      dataField: "valSup",
      text: "Revised Value of supplies returned",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        return { fontFamily, fontSize, fontWeight, textAlign };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "20%",
      },
      formatter:(col, row)=>{
        return (
          <>
          {(row.valSup != null && row.valSup != undefined)?displayValue(row.valSup):"--"}
          </>
        )
      }
    //   formatter: (cell, row) => {
    //     return (
    //       <div
    //         style={{ width: "100%" }}
    //         onClick={row.pass != "0" ? () => downloadFile(row, "pass") : ""}
    //       >
    //         {row.pass}
    //       </div>
    //     );
    //   },
    },
    {
      dataField: "netAmtSup",
      text: "Revised Net value of Supplies",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        return { fontFamily, fontSize, fontWeight, textAlign };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "20%",
      },
      formatter:(col, row)=>{
        return (
          <>
          {(row.netAmtSup != null && row.netAmtSup != undefined)?displayValue(row.netAmtSup):"--"}
          </>
        )
      }
    },
   
  ];
  return (
    <div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex" }} >
          <Button
          onClick={()=>{props.setShowViewTab(false)}}
            variant="outlined"
            color="primary"
            startIcon={<ArrowBackIosIcon />}
            style={{
              //   backgroundColor: "#4f2d7f",
              color: "#4f2d7f",
              height: "30px",
              textTransform: "capitalize",
              marginTop:'4px'
            }}
          >
            Back
          </Button>{" "}
          <div className="span-text">4.1 Amendment to supplies made by un-registered suppliers</div></div>
          <div style={{ display: "flex" }}>
          <div  className="search-custom">
            <CustomTextField
           
           onChange={(e)=>setSearch(e.target.value)}
               value={search}
              placeholder="Search"
              variant="outlined"
              size="small"
              // onChange={handleInputChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
            
          </div>
          <Button
              variant="contained"
              color="primary"
              onClick={()=>props.getViewTableData(props.supType,search)}
              style={{
                backgroundColor: "#4f2d7f",
                color: "white",
                height: "30px",
marginTop:"4px",
padding: '0em 2em',
                textTransform: "capitalize",
              }}
            >
              Search
            </Button>
            </div>
        </div>
        {(() => {
          const headers = [
            "GSTIN of ECO",
            "Original Return Period",
            "Original Enrolment no.",
            "Revised Enrolment no.",
            "Revised Name of Supplier",
            "Gross value of supplies made",
            "Value of supplies returned",
            "Net value of Supplies",
          ];

          const formatAmount = (v) => {
            if (v === null || v === undefined || v === "" || isNaN(Number(v))) return "--";
            return Number(v).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          };

          const rows = [];
          if (props.viewTabData && props.viewTabData.length > 0) {
            props.viewTabData.forEach((item, idx) => {
              // support both flat items and nested data_json arrays
              if (item.data_json && item.data_json.length > 0) {
                item.data_json.forEach((sin, sidx) => {
                  rows.push(
                    <tr key={`${idx}-${sidx}`} className={idx % 2 === 0 ? "even" : "odd"}>
                      <td className="text-left">{sin.gstin ||  item.gstin || "--"}</td>
                      <td className="text-left">{sin.ofp || sin.originalReturnPeriod || item.ofp || item.originalReturnPeriod || "--"}</td>
                      <td className="text-left">{ sin.oeid || item.oeid || "--"}</td>
                      <td className="text-left">{sin.eid  || item.eid || "--"}</td>
                      <td className="text-left">{sin.supName || sin.name || sin.supplierName || item.supName || "--"}</td>
                      <td className="numeric">{formatAmount(sin.grossValSup)}</td>
                      <td className="numeric">{formatAmount(sin.valSup)}</td>
                      <td className="numeric">{formatAmount(sin.netAmtSup)}</td>
                    </tr>
                  );
                });
              } else {
                rows.push(
                  <tr key={idx} className={idx % 2 === 0 ? "even" : "odd"}>
                    <td className="text-left">{item.gstin || item.stin || "--"}</td>
                    <td className="text-left">{item.ofp || item.returnPeriod || item.originalReturnPeriod || props.selectedPeriod || props.selectedPeriodSingle || "--"}</td>
                    <td className="text-left">{item.originalEid || item.eid || "--"}</td>
                    <td className="text-left">{item.revisedEid || item.eid || "--"}</td>
                    <td className="text-left">{item.supName || item.name || item.supplierName || "--"}</td>
                    <td className="numeric">{formatAmount(item.grossValSup)}</td>
                    <td className="numeric">{formatAmount(item.valSup)}</td>
                    <td className="numeric">{formatAmount(item.netAmtSup)}</td>
                  </tr>
                );
              }
            });
          }

          return (
            <div>
              {rows && rows.length > 0 ? (
                <div className="tableWrapper" style={{ marginTop: "1em" }}>
                  <table className="gst-table">
                    <thead>
                      <tr>
                        {headers.map((h) => (
                          <th key={h}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {rows}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div
                  style={{
                    height: "40vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography style={{ fontWeight: "800" }}>No Data Available</Typography>
                </div>
              )}
            </div>
          );
        })()}
        
    </div>
  );
};

export default Table41;
